import ListOrder from '../sub-pages/list-order';

export default [
    {
        show(row, extra) {
            return row.fpbj === '2'
        },
        tag: 'my-btn',
        type: 'detail',
        text: '详细',
        click(row, extra) {
            this.goto({
                path: './form',
                query: {
                    orderid: row.orderscode
                }
            });
        }
    },
    {
        show(row, extra) {
            return true
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-document-copy',
        text: '详细订单',
        click(row, extra) {
            this.dialogOpen(ListOrder, '详细订单');
        }
    },
    {
        show(row, extra) {
            return row.fpbj === '1'
        },
        tag: 'el-button',
        type: 'text',
        icon: 'el-icon-s-ticket',
        text: '开票',
        click(row, extra) {
            this.goto({
                path: './form',
                query: {
                    orderid: row.orderscode
                }
            });
        }
    },
    {
        show(row, extra) {
            return (
                row.fpbj === '2'
                && row.dwcode === 'E0000001881'
            )
        },
        tag: 'el-button',
        type: 'text',
        text: '退票',
        click(row, extra) {
            window.ShowConfirm('确定冲红吗', 'warning', () => {
                this.$post(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/tuipiao.json`, {
                    orderscode: row.orderscode
                }, data => {
                    ShowMsg('退票/冲红成功','success');
                    this.$emit('reload');
                });
            })
        }
    },
]
